import React from 'react';
import Summary from './Summary';
import { formatCurrency } from '../../utils/currency.utils';
import InvoiceCarReceiptCard from './InvoiceCarReceiptCard';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import TitleSummaryList from '../tripSummary/TitleSummary';
import { useSelector } from 'react-redux';
import {
  selectCompanyCurrency,
  selectCompanyCurrencyCulture,
} from '../../store/selectors/auth.selector';
const InvoiceCarSummaryList = ({ response, passengers, onSelect }) => {
  const { t } = useTranslation(i18nNS.tripSummary);
  const { tKey } = useComponentTKey('CarReceiptSummaryList');
  const currency = useSelector(selectCompanyCurrency);
  const currencyCulture = useSelector(selectCompanyCurrencyCulture);
  return (
    <>
      <TitleSummaryList
        iconName="car"
        desc={
          response.NoOfDays + ' ' + (response.NoOfDays === 1 ? t(tKey('Day')) : t(tKey('Days')))
        }
        amount={formatCurrency(response.TotalCost, currency, currencyCulture, 2)}
      />
      <Summary>
        <InvoiceCarReceiptCard
          item={response}
          passengers={passengers}
          onPress={onSelect}
          disableDetails
          hidePrice
        />
      </Summary>
    </>
  );
};

export default InvoiceCarSummaryList;
